import UserTips from "./index";

export default { path: "/home/usertips", component: UserTips };
